<template>
  <div>
    <layout-header title="Trámite ICI" subtitle="Informe sobre cumplimiento de las normas internas individual y consolidado de las ESI">
      <ets-button-group v-if="isAllowed">
        <ets-button class="button" icon="download" title="Vista de Descargas" :selected="showDownload" @click="toggleViews('download')" />
        <ets-button
          class="button"
          icon="pencil"
          title="Vista de Generación"
          :disabled="canGenerateICI"
          :selected="showGenerate"
          @click="toggleViews('generate')"
        />
      </ets-button-group>
      <ets-button
        v-if="isAllowed"
        icon="add"
        title="Generar XML"
        :mode="mode"
        :class="{ button: !showDownload }"
        :loading="isDownloadingXML"
        :disabled="showDownload"
        @click="onSubmit"
      />
    </layout-header>
    <ets-page>
      <template v-if="isAllowed">
        <ets-alert type="info">Presentar antes de: 15 de Mayo</ets-alert>
        <download-section v-if="showDownload" ref="downloadSection" procedure="ici" @reports-loaded="onReportsLoaded" />
        <div v-if="showGenerate" class="page">
          <ets-module title="Datos Identificativos" class="module">
            <table>
              <tr>
                <th class="label tax-year">Ejercicio</th>
                <td>{{ taxYear }}</td>
              </tr>
            </table>
          </ets-module>
          <ets-module title="Identificación Entidad" class="module">
            <table>
              <tr v-for="id in identifications" :key="id.key">
                <th class="label">{{ id.key }}</th>
                <td>{{ id.value }}</td>
              </tr>
            </table>
          </ets-module>
          <ets-module title="Datos de contacto" class="module">
            <div class="input-wrapper">
              <ets-input
                placeholder="Nombre"
                label="Nombre"
                v-model="name"
                class="ets-input"
                :hasValidation="showErrorsName"
                :showAll="showErrors"
              />
            </div>
            <div class="input-wrapper">
              <ets-input
                placeholder="Teléfono"
                label="Teléfono"
                v-model="phone"
                class="ets-input"
                :hasValidation="showErrorsPhone"
                :showAll="showErrors"
              />
            </div>
            <div class="input-wrapper">
              <ets-input
                placeholder="Cargo"
                label="Cargo"
                v-model="position"
                class="ets-input"
                :hasValidation="showErrorsPosition"
                :showAll="showErrors"
              />
            </div>
            <div class="input-wrapper">
              <ets-input
                placeholder="Email"
                label="Email"
                v-model="email"
                class="ets-input"
                :hasValidation="showErrorsEmail"
                :showAll="showErrors"
              />
            </div>
          </ets-module>
          <ets-module title="Documentos adjuntos" class="module">
            <table>
              <tr class="uploader-row">
                <th class="label">Informe Interno</th>
                <td>
                  <ets-file-uploader
                    @uploaded="getFile($event, 'report')"
                    :display-filename="true"
                    text-button="Añadir Fichero"
                    uploadFieldName="report"
                    id="report"
                    class="uploader"
                    :hasValidation="showErrorsReport"
                    :showAll="showErrors"
                    labelName="Informe Interno"
                    title="informeci.pdf"
                  />
                </td>
              </tr>
              <tr class="uploader-row">
                <th class="label">Acta del Consejo</th>
                <td>
                  <ets-file-uploader
                    @uploaded="getFile($event, 'acta')"
                    :display-filename="true"
                    text-button="Añadir Fichero"
                    uploadFieldName="acta"
                    id="acta"
                    class="uploader"
                    :hasValidation="showErrorsActa"
                    :showAll="showErrors"
                    labelName="Acta del Consejo"
                    title="actaconsejo.pdf"
                  />
                </td>
              </tr>
              <tr class="uploader-row">
                <th class="label">Declaración del Secretario</th>
                <td>
                  <ets-file-uploader
                    @uploaded="getFile($event, 'declara')"
                    :display-filename="true"
                    text-button="Añadir Fichero"
                    uploadFieldName="declara"
                    id="declara"
                    class="uploader"
                    :hasValidation="showErrorsDeclara"
                    :showAll="showErrors"
                    labelName="Declaración del Secretario"
                    title="declara.pdf"
                  />
                </td>
              </tr>
            </table>
          </ets-module>
        </div>
        <popup-errors :displayErrors="displayErrors" :errors="errors" @display-errors="updateDisplayErrors" />
        <popup-generated :displayGenerate="displayGenerate" @display-generate="updateDisplayGenerate" />
        <popup-not-generated
          :displayNotGenerate="displayNotGenerate"
          @display-not-generate="updateDisplayNotGenerate"
          @generate-procedure="generateNewProcedure()"
        />
      </template>
      <forbidden v-else />
    </ets-page>
  </div>
</template>

<script>
import { mapState } from "vuex";
import dayjs from "dayjs";
import compliance from "@/logic/api/compliance";
import validations from "@/mixins/validations";
import LayoutHeader from "@/components/Layout/LayoutHeader";
import DownloadSection from "@/components/Download/DownloadSection";
import Forbidden from "@/components/Forbidden";
import PopupGenerated from "@/components/Popup/PopupGenerated";
import PopupErrors from "@/components/Popup/PopupErrors";
import PopupNotGenerated from "@/components/Popup/PopupNotGenerated";

export default {
  name: "PageICI",
  mixins: [validations],
  components: {
    LayoutHeader,
    Forbidden,
    DownloadSection,
    PopupGenerated,
    PopupErrors,
    PopupNotGenerated
  },
  data: () => ({
    mode: "",
    isDownloadingXML: false,
    data: null,
    identifications: null,
    errors: [],
    displayErrors: false,
    displayGenerate: false,
    showErrors: false,
    taxYear: dayjs()
      .subtract(1, "year")
      .year()
      .toString(),
    name: "Mercedes Martínez Cunha",
    phone: "917401163",
    position: "Directora Recursos Humanos",
    email: "mmartinez@etsfactory.com",
    fileReport: null,
    fileActa: null,
    fileDeclara: null,
    showDownload: true,
    showGenerate: false,
    notGenerated: false,
    displayNotGenerate: false
  }),
  created() {
    compliance.getCorporateData().then(response => {
      this.identifications = [
        { key: "Tipo Entidad", value: response.data.entityType },
        { key: "Nº Registro", value: response.data.officialRegistrationNumber },
        { key: "Denominación", value: response.data.companyName }
      ];
      if (typeof response.data.contactName1 !== "undefined") {
        this.name = response.data.contactName1;
        this.phone = response.data.contactTlf1;
        this.position = response.data.contactJobTitle1;
        this.email = response.data.contactEmail1;
      }
    });
  },
  computed: {
    ...mapState(["userPermissions"]),
    canGenerateICI() {
      let oneweekmore = dayjs()
        .set("month", 4)
        .set("date", 15)
        .add(2, "week");
      return dayjs().isAfter(oneweekmore);
    },
    isAllowed() {
      return this.userPermissions && this.userPermissions.EAFI_E_ProcedureICI;
    }
  },
  methods: {
    validate() {
      this.errors = [];
      this.nameValidation();
      this.phoneValidation();
      this.positionValidation();
      this.emailValidation();
      this.reportValidation();
      this.actaValidation();
      this.declaraValidation();
      return this.errors.length === 0;
    },
    getFile(file, inputFile) {
      switch (inputFile) {
        case "report":
          this.fileActa = file.getAll(inputFile)[0];
          break;
        case "acta":
          this.fileReport = file.getAll(inputFile)[0];
          break;
        case "declara":
          this.fileDeclara = file.getAll(inputFile)[0];
          break;
      }
    },
    onSubmit() {
      if (this.validate()) {
        let data = {
          taxYear: this.taxYear,
          name: this.name,
          phone: this.phone,
          position: this.position,
          email: this.email,
          fileReport: this.fileReport,
          fileActa: this.fileActa,
          fileDeclara: this.fileDeclara
        };
        this.data = data;
        this.showErrors = false;
        this.generateXML();
      } else {
        this.displayErrors = true;
        this.showErrors = true;
        this.data = null;
      }
    },
    async generateXML() {
      this.isDownloadingXML = true;
      await compliance.generateICI(this.data);
      this.displayGenerate = true;
      this.isDownloadingXML = false;
    },
    toggleViews(view) {
      this.showDownload = false;
      this.showGenerate = false;
      switch (view) {
        case "download":
          this.showDownload = true;
          this.mode = "";
          break;
        case "generate":
          this.showGenerate = true;
          this.mode = "main";
          break;
      }
    },
    needGenerate(e) {
      this.notGenerated = e;
      this.displayNotGenerate = e;
    },
    generateNewProcedure() {
      this.toggleViews("generate");
      this.displayNotGenerate = false;
    },
    updateDisplayGenerate(e) {
      this.toggleViews("download");
      this.displayGenerate = e;
    },
    updateDisplayErrors(e) {
      this.displayErrors = e;
    },
    updateDisplayNotGenerate(e) {
      this.displayNotGenerate = e;
    },
    onReportsLoaded(reports) {
      if (reports.length === 0) {
        this.generateNewProcedure();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.module {
  ::v-deep .form-input {
    margin: 0.5rem 0;
  }
  ::v-deep .text {
    width: 100%;
    color: #7f8c8d;
    border-bottom: 1px solid #a8b5b6;
    margin-top: 0;
    font-weight: normal;
  }
}
.page .ets-module {
  margin-bottom: 1rem;
}
.input-wrapper {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
}
.ets-input {
  display: flex;
  align-items: baseline;
  ::v-deep .input {
    width: 34rem;
    height: 3rem;
  }
  ::v-deep .label {
    width: 8rem;
  }
}
tr {
  line-height: 2.5rem;
}
th {
  text-align: left;
}
td {
  padding-left: 2rem;
}
.label {
  font-weight: bold;
  font-size: 1.3rem;
  font-family: Open Sans Condensed, sans-serif;
}
.tax-year {
  width: 7.6rem;
}
.dropper {
  width: 50%;
}
.uploader {
  ::v-deep .custom-file-upload {
    min-height: 2rem;
    padding: 0.5rem 1rem;
    background-color: #f5f5f5;
    background-image: none;
    border-color: #7f8c8d;
    &:hover {
      background-color: $color-grey5;
      background-image: none;
      border-color: $color-grey;
    }
  }
  ::v-deep .text {
    border-bottom: none;
    color: $color-grey;
    font-size: 1.3rem;
    vertical-align: none;
  }
}
.uploader-row {
  line-height: 0.75rem;
}
.button {
  cursor: pointer;
}
</style>
